import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { EyeIcon, EyeSlashIcon } from '@omilia/icon';
import { getThemeProp } from 'styles/theme';
import { MessageStatus } from 'types';

const statusBackgroundColor = {
  [MessageStatus.PENDING]: colors.COLOR_GREY_100,
  [MessageStatus.ERROR]: colors.COLOR_RED_100,
  [MessageStatus.SENT]: null,
};

const statusBorder = {
  [MessageStatus.PENDING]: `1px solid ${colors.COLOR_GREY_900}`,
  [MessageStatus.ERROR]: `1px solid ${colors.COLOR_RED_700}`,
  [MessageStatus.SENT]: null,
};

const statusTextColor = {
  [MessageStatus.PENDING]: colors.COLOR_GREY_900,
  [MessageStatus.ERROR]: colors.COLOR_RED_700,
  [MessageStatus.SENT]: colors.COLOR_WHITE,
};

export const SSensitiveBubble = styled.div<{ status?: MessageStatus }>`
  align-items: center;
  background-color: ${({ status }) =>
    statusBackgroundColor[status] ?? getThemeProp('primaryColor')};
  border: ${({ status }) => statusBorder[status] ?? 'none'};
  border-radius: 16px;
  color: ${({ status }) => statusTextColor[status] ?? colors.COLOR_WHITE};
  display: flex;
  font-family: ${getThemeProp('fontFamily')};
  font-size: 14px;
  gap: 8px;
  line-height: 1.5;
  max-width: 100%;
  padding: 12px 16px;
  word-break: break-word;
`;

export const SSensitiveText = styled.span`
  flex: 1;
  min-width: 0;
`;

export const SRevealButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 0;

  &:focus {
    outline: none;
  }
`;

export const SEyeIcon = styled(EyeIcon)`
  cursor: pointer;
`;

export const SEyeSlashIcon = styled(EyeSlashIcon)`
  cursor: pointer;
`;
